import type { Article } from '@/mocks/articles';
import { categoryName, formatHeat, formatLike } from '@/utils/content';
import { Link } from 'react-router-dom';

export default function TrendList({ items }: { items: Article[] }) {
  return (
    <div className="flex h-full flex-col gap-1">
      {items.map((a, idx) => {
        const top = idx < 3;
        return (
          <Link
            key={a.id}
            to={`/article/${a.id}`}
            className="group flex items-start gap-3 rounded-xl px-2 py-2 transition-colors hover:bg-cream-100"
          >
            <span
              className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-lg text-sm font-bold ${
                top ? 'bg-primary-500 text-cream-50' : 'bg-cream-200 text-ink-600'
              }`}
            >
              {idx + 1}
            </span>
            <span className="min-w-0 flex-1">
              <span className="line-clamp-2 block text-sm font-medium leading-snug text-ink group-hover:text-primary-600">
                {a.title}
              </span>
              <span className="mt-1 flex items-center gap-2 text-xs text-ink-600">
                <span className="text-primary-600">{categoryName(a.categoryId)}</span>
                <span>
                  <i className="ri-fire-fill mr-0.5 text-primary-500" />
                  {formatHeat(a.heat)}
                </span>
                <span>
                  <i className="ri-chat-3-line mr-0.5" />
                  {formatLike(a.commentCount)}
                </span>
              </span>
            </span>
          </Link>
        );
      })}
    </div>
  );
}